module.exports = __webpack_public_path__ + "img/鸿新云小程序_二维码.2a29e888.png";